import * as React from "react";
import { Route, Switch } from "react-router-dom";
import IUserSession from "../../types/IUserSession";
import ChangeCustomerContainer from "../ChangeCustomer/ChangeCustomerContainer";
import ChangePasswordContainer from "../ChangePassword/ChangePasswordContainer";
import ClientEditContainer from "../ClientEdit/ClientEditContainer";
import ClientListContainer from "../ClientList/ClientListContainer";
import DashboardContainer from "../Dashboard/DashboardContainer";
import ForgotPasswordContainer from "../ForgotPassword/ForgotPasswordContainer";
import LicenseKeyEditContainer from "../LicenseKeyEdit/LicenseKeyEditContainer";
import LicenseKeyListContainer from "../LicenseKeyList/LicenseKeyListContainer";
import LoginContainer from "../Login/LoginContainer";
import LoginToClientContainer from "../LoginToClient/LoginToClientContainer";
import MessageDetailContainer from "../MessageDetail/MessageDetailContainer";
import MessagesContainer from "../MessageList/MessageListContainer";
import MessageRecipientListContainer from "../MessageRecipientList/MessageRecipientListContainer";
import NotFound from "../NotFound/NotFound";
import PostbackLogListContainer from "../PostbackLogList/PostbackLogListContainer";
import RegisterContainer from "../Register/RegisterContainer";
import RegisterRequestContainer from "../RegisterRequest/RegisterRequestContainer";
import ResetPasswordContainer from "../ResetPassword/ResetPasswordContainer";
import SendMessageContainer from "../SendMessage/SendMessageContainer";
import UserEditContainer from "../UserEdit/UserEditContainer";
import UserListContainer from "../UserList/UserListContainer";
import PrivateRoute from "./PrivateRoute";

interface IRouteProps {
    onLogin: (userSession: IUserSession) => void;
}

class Routes extends React.Component<IRouteProps> {

    constructor(props: IRouteProps) {
        super(props);
        this.getLoginComponent = this.getLoginComponent.bind(this);
        this.getRegisterComponent = this.getRegisterComponent.bind(this);
        this.getResetPasswordComponent = this.getResetPasswordComponent.bind(this);
        this.getChangeCustomerComponent = this.getChangeCustomerComponent.bind(this);
        this.getLoginToClientComponent = this.getLoginToClientComponent.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <Switch>
                    <Route path="/forgotPassword" component={ForgotPasswordContainer} />
                    <Route path="/login" render={this.getLoginComponent} />
                    <Route path="/register/:registrationCode" render={this.getRegisterComponent} />
                    <Route path="/registerRequest" component={RegisterRequestContainer} />
                    <Route path="/resetPassword/:resetCode" render={this.getResetPasswordComponent} />
                    <PrivateRoute exact={true} path="/" component={DashboardContainer} />
                    <PrivateRoute path="/changeCustomer/:clientHeaderID" render={this.getChangeCustomerComponent} />
                    <PrivateRoute path="/changePassword" component={ChangePasswordContainer} />
                    <PrivateRoute path="/clients" component={ClientListContainer} />
                    <PrivateRoute path="/client/:clientID?" component={ClientEditContainer} />
                    <PrivateRoute path="/dashboard" component={DashboardContainer} />
                    <PrivateRoute path="/licenseKeys" component={LicenseKeyListContainer} />
                    <PrivateRoute path="/licenseKey/:clientDetailID?" component={LicenseKeyEditContainer} />
                    <PrivateRoute path="/loginToClient/:clientHeaderID" render={this.getLoginToClientComponent} />
                    <PrivateRoute path="/users" component={UserListContainer} />
                    <PrivateRoute path="/user/:userID?" component={UserEditContainer} />
                    <PrivateRoute path="/messages" component={MessagesContainer} />
                    <PrivateRoute path="/message/:messageID/:messageType" component={MessageDetailContainer} />
                    <PrivateRoute path="/messageRecipients" component={MessageRecipientListContainer} />
                    <PrivateRoute path="/sendMessage" component={SendMessageContainer} />
                    <PrivateRoute path="/postbackLogs" component={PostbackLogListContainer} />
                    <Route component={NotFound} />
                </Switch>
            </div>
        );
    }

    private getLoginComponent(): React.ReactNode {
        return <LoginContainer onLogin={this.props.onLogin} />;
    }

    private getRegisterComponent(): React.ReactNode {
        return <RegisterContainer onLogin={this.props.onLogin} />;
    }

    private getResetPasswordComponent(): React.ReactNode {
        return <ResetPasswordContainer onLogin={this.props.onLogin} />;
    }

    private getChangeCustomerComponent(): React.ReactNode {
        return <ChangeCustomerContainer onLogin={this.props.onLogin} />;
    }

    private getLoginToClientComponent(): React.ReactNode {
        return <LoginToClientContainer onLogin={this.props.onLogin} />;
    }
    
}

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routing/Routes.tsx